import { render, staticRenderFns } from "./SwimProps.vue?vue&type=template&id=274ed72f&scoped=true"
import script from "./SwimProps.vue?vue&type=script&lang=js"
export * from "./SwimProps.vue?vue&type=script&lang=js"
import style0 from "./SwimProps.vue?vue&type=style&index=0&id=274ed72f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ed72f",
  null
  
)

export default component.exports